import { render, staticRenderFns } from "./ShowNetPriceSwitch.vue?vue&type=template&id=5f098edd&"
import script from "./ShowNetPriceSwitch.vue?vue&type=script&lang=js&"
export * from "./ShowNetPriceSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f098edd')) {
      api.createRecord('5f098edd', component.options)
    } else {
      api.reload('5f098edd', component.options)
    }
    module.hot.accept("./ShowNetPriceSwitch.vue?vue&type=template&id=5f098edd&", function () {
      api.rerender('5f098edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/ShowNetPriceSwitch.vue"
export default component.exports